import '@babel/polyfill';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import AgendaTouchpoint from 'common/compounds/AgendaTouchpoint';
import fontLoader from 'utils/fontLoader';
import { getInstance as getBootstrap } from 'utils/bootstrap';

/**
 * Get the bootstrap data that PHP left for us
 */
const bootstrap = getBootstrap();
const eventId = parseInt(bootstrap.get('event.id', null), 10);
const eventTitle = bootstrap.get('event.title', '');
const availableFonts = bootstrap.get('availableFonts', []);

if (availableFonts.length) {
    fontLoader(availableFonts);
}

const root = createRoot(document.getElementById('root'));

root.render(
    <Router>
        <AgendaTouchpoint eventId={eventId} eventTitle={eventTitle} editable={false} />
    </Router>,
);
